export class FetchAbstractSubscriptionsAction {
  static readonly type = '[Payment] Fetch Abstract Subscriptions';
  constructor() {}
}
